import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'

const OmnichannelPlatform = () => {
  return (
    <Screen
      title={<span>Виртуальная АТС + Чаты =<StyledScreen.GreenText> Омниканальная</StyledScreen.GreenText> платформа</span>}
      bottomLine
      className='omnichannel-platform'
    >
      <div className='omnichannel-platform__container'>
        <p className='omnichannel-platform__text'>Омниканальная платформа — это возможность общаться с клиентом там, где ему удобно, при этом фиксируя любую коммуникацию с клиентом в CRM прямо в карточке сделки. </p>
        <p className='omnichannel-platform__text omnichannel-platform__text_bolt'>При звонке в отдел продаж или переписке в WhatsApp вся история общения подгрузится в CRM, и менеджер сможет работать с клиентами в режиме одного окна.</p>
        <p className='omnichannel-platform__text'>Данные по клиенту не потеряются и не останутся в личных переписках менеджеров. История переписки и история звонков останутся у вас даже при смене менеджера.</p>
      </div>
    </Screen>
  );
};

export default OmnichannelPlatform